/**
 * @author        quanquan
 * @dateTime      2020-12-08 17:19:14
 * @description   堆栈IO
 */

let num = 1
let ioArr = []
let requestMap = {}
let loading = false

let pFactor = function (b, d) {
  return () => {
    return new Promise((resolve, reject) => {
      let io = b()
      io.then(() => {
        resolve()
        d(io)
      }).catch(() => {
        resolve()
        d(io)
      })
    })
  }
}

let req = function () {
  if (loading) {
    return
  }
  if (ioArr.length > 0) {
    loading = true
    let arr = ioArr.splice(0, num)
    arr.forEach((p, i) => {
      arr[i] = p.func()
    })
    Promise.all(arr).then(() => {
      loading = false
      req()
    })
  }
}

let clearIO = function () {
  ioArr = []
  requestMap = {}
  loading = false
}

export { clearIO }

export default function (b, d, bookID, reqID) {
  requestMap[bookID] = reqID
  const index = ioArr.find(i => i.bookID === bookID)
  if (index) {
    ioArr.splice(index, 1)
  }
  ioArr.push({ bookID, func: pFactor(b, d) })
  req()
}



// WEBPACK FOOTER //
// ./src/js/module/components/mtIm/_source/heapIo.js